import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "../styles/SelectNewCyclistsBonus.css";

const SelectNewCyclistsBonus = ({
  selectedCyclists,
  selectedActualCyclists,
  selectedNewCyclists,
  setCyclistsBonus,
  cyclistsBonus,
  nextStep,
  prevStep,
  teamId,
  saveData,
}) => {
  const { t } = useTranslation();
  const [isDone, setIsDone] = useState(false);
  const navigate = useNavigate();

  const pickable = useMemo(() => {
    const merged = [...(selectedCyclists || []), ...(selectedNewCyclists || [])];
    const locked = new Set((selectedActualCyclists || []).map((c) => c?.cyclistId).filter((id) => id != null));

    return merged.filter((c) => {
      const id = c?.cyclistId;
      if (id == null) return false;
      if (locked.has(id)) return false;
      return Number(c?.finalValue || 0) < 5;
    });
  }, [selectedCyclists, selectedNewCyclists, selectedActualCyclists]);

  const hasBonus = (id) => (cyclistsBonus || []).some((c) => c?.cyclistId === id);

  const toggleBonus = (cyclist) => {
    const id = cyclist?.cyclistId;
    if (id == null) return;

    if (hasBonus(id)) {
      setCyclistsBonus((cyclistsBonus || []).filter((c) => c?.cyclistId !== id));
      return;
    }
    setCyclistsBonus([...(cyclistsBonus || []), cyclist]);
  };

  const submit = () => {
    saveData()
      .then(() => setIsDone(true))
      .catch(() => {});
  };

  const close = () => navigate("/profil");

  return (
    <main className="select-new-cyclists-bonus">
      {isDone && (
        <div className="select-new-cyclists-bonus-popup">
          <div className="select-new-cyclists-bonus-popup-content">
            <p>
              {t("swapBonusCyclist.successLine1")}
              <br />
              {t("swapBonusCyclist.successLine2")}
            </p>
            <button onClick={close}>{t("swapBonusCyclist.successBtn")}</button>
          </div>
        </div>
      )}

      <div className="select-new-cyclists-bonus-shadow-container">
        <div className="select-new-cyclists-bonus-title">
          <h1>{t("swapBonusCyclist.pageTitle")}</h1>
          <div className="select-new-cyclists-bonus-shadow-mask-right"></div>
          <div className="select-new-cyclists-bonus-shadow-mask-bottom"></div>
        </div>
      </div>

      <div className="select-new-cyclists-bonus-header">
        <div className="select-new-cyclists-bonus-rules">
          <p>{t("swapBonusCyclist.pageHint")}</p>
        </div>

        <div className="select-new-cyclists-bonus-change-step">
          <button onClick={prevStep}>{t("swapBonusCyclist.backBtn")}</button>
          <button onClick={teamId === 1 ? nextStep : submit} disabled={(cyclistsBonus || []).length > 1}>
            {t("swapBonusCyclist.nextBtn")}
          </button>
        </div>
      </div>

      <div className="select-new-cyclists-bonus-pannel-view">
        <div className="select-new-cyclists-bonus-choice">
          <div className="select-new-cyclists-bonus-table-container">
            <table>
              <thead>
                <tr>
                  <th>{t("swapBonusCyclist.cols.rider")}</th>
                  <th>{t("swapBonusCyclist.cols.squad")}</th>
                  <th>{t("swapBonusCyclist.cols.country")}</th>
                  <th>{t("swapBonusCyclist.cols.worth")}</th>
                  <th>{t("swapBonusCyclist.cols.role")}</th>
                </tr>
              </thead>
              <tbody>
                {pickable.map((cyclist) => (
                  <tr
                    key={cyclist.cyclistId}
                    onClick={() => toggleBonus(cyclist)}
                    className={hasBonus(cyclist.cyclistId) ? "select-new-cyclists-bonus-table-selected-row" : ""}
                  >
                    <td>
                      <div className="select-new-cyclists-bonus-name-info">
                        <img
                          className="select-new-cyclists-bonus-flag-icon"
                          src={`${process.env.PUBLIC_URL}/flags/${(cyclist.nationality || "")
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "")
                            .replace(/ /g, "_")
                            .toLowerCase()}.png`}
                          alt={t("swapBonusCyclist.flagAlt", { country: cyclist.nationality })}
                          width="20"
                          height="20"
                        />
                        <span>{cyclist.name}</span>
                      </div>
                    </td>
                    <td>{cyclist.team}</td>
                    <td>{cyclist.nationality}</td>
                    <td>{cyclist.finalValue}</td>
                    <td>{cyclist.speciality}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="select-new-cyclists-bonus-line-container">
          {(cyclistsBonus || []).map((cyclist) => (
            <div className="select-new-cyclists-bonus-selected-cell" key={cyclist.cyclistId}>
              <div className="select-new-cyclists-bonus-selected-info">
                <img
                  src={`${process.env.PUBLIC_URL}/icons/cancel.png`}
                  className="select-new-cyclists-bonus-cancel-icon"
                  alt={t("swapBonusCyclist.removeAlt")}
                  width="17"
                  height="17"
                  onClick={() => toggleBonus(cyclist)}
                />
                <h4>
                  <img
                    className="select-new-cyclists-bonus-flag-icon"
                    src={`${process.env.PUBLIC_URL}/flags/${(cyclist.nationality || "")
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                      .replace(/ /g, "_")
                      .toLowerCase()}.png`}
                    alt={t("swapBonusCyclist.flagAlt", { country: cyclist.nationality })}
                    width="20"
                    height="20"
                  />
                  {cyclist.name}
                </h4>
                <p>{cyclist.team}</p>
                <p>
                  {t("swapBonusCyclist.worthLine")} <strong>{cyclist.finalValue}</strong>
                </p>
                <div
                  style={{
                    width: "100%",
                    height: "15px",
                    backgroundColor: cyclist.teamColor,
                    marginTop: "35px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default SelectNewCyclistsBonus;
